import React from "react";
import { Button, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from "reactstrap";
import { Form, SubmitField } from "react-components-form";
import { CheckboxField, DropzoneField, SelectField, TextareaField, TextField } from "../../../../shared/Form";
import { Basemap, Fullscreen, GeoJSONLayer, GraphicsLayer, Locate, PointDraw, Polygon } from "../../../../libs/arcgis";

import { withNamespaces } from "react-i18next";

import problemTypeApi from "../../../../apiV2/problemTypesApi";
import problemTypeGroupApi from "../../../../apiV2/problemTypeGroupsApi";
import problemsApi from "../../../../apiV2/problemsApi";
import { problemObjectSchema } from "../../../../schemas/problemObjectSchema";
import i18n from "i18next";
import cityObjectApi from "../../../../apiV2/cityObjectApi";
import { addMessage } from "../../../../store/actions";
import { connect } from "react-redux";
import ProxyLayers from "../../../../libs/arcgis/ProxyLayers";
import objectOwnersApiV2 from "../../../../apiV2/objectOwnersApi";
import { convertHex2Array } from "../../../../utils";
import { prepareServiceIntensityLayers, setServiceIntensityLayerRenderer } from "../../../../libs/arcgis/layers/utils";

const mapDispatchToProps = { addMessage };

class ConnectedProblemForm extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            isOpen: false,
            typeGroupOptions: [],
            typeOptions: [],
            isNotification: false
        };

        this.problemForm = React.createRef();
    }

    componentDidMount() {
        problemTypeGroupApi.all().then(result => {
            let types = [];

            types.push({
                label: this.props.t('fields.select'),
                value: ''
            });

            for (let el of result) {
                types.push({
                    label: el.name,
                    value: el.id
                });
            }

            this.setState({
                typeGroupOptions: types
            });

            if (this.props.cityObject.geom.point && this.problemForm.current) {
                this.problemForm.current.setModel('pointX', this.props.cityObject.geom.point.x);
                this.problemForm.current.setModel('pointY', this.props.cityObject.geom.point.x);
            }
        });

        let objectOwners = [];
        objectOwnersApiV2.all().then(res => {
            objectOwners = res.map((item) => {
                return {
                    value: item.id,
                    label: item.name
                };
            });

            this.setState({
                objectOwners: objectOwners
            });
        });
    }

    toggle = () => {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen,
            typeOptions: []
        }));

        this.problemForm.current.resetListener();
    };

    handleSubmit = (model) => {
        if (model.pointX === 0) {
            this.props.addMessage({
                type: "error",
                message: this.props.t("messages.discrepancyMustBeInside")
            });
        } else {
            problemsApi.createPublic(model).then(() => {
                this.props.addMessage({
                    type: "success",
                    message: this.props.t("messages.wasCreated", {
                        item: this.props.t('header.problem')
                    })
                });
                this.toggle();
            });
        }
    };

    handleChangeGroup = (value) => {
        // Get problem types
        problemTypeApi.getByGroup(value).then(result => {
            let types = [];

            types.push({
                label: this.props.t('fields.select'),
                value: ''
            });

            for (let el of result) {
                types.push({
                    label: el.title,
                    value: el.id
                });
            }

            this.setState({
                typeOptions: types
            });
        });
    };

    handleProblemLocationChange = (coordinates) => {
        cityObjectApi.contains(this.props.cityObject.id, coordinates[0], coordinates[1]).then(result => {
            if (result) {
                this.problemForm.current.setModel('pointX', coordinates[0]);
                this.problemForm.current.setModel('pointY', coordinates[1]);
            } else {
                this.props.addMessage({
                    type: "error",
                    message: this.props.t("messages.discrepancyMustBeInside")
                });
            }
        });
    };

    handleNotification = (value) => {
        this.setState({ isNotification: value })
    };

    handleSetOwner = (value) => {
        if (value) {
            let isFound = false;
            for (let owner of this.state.objectOwners) {
                if (value['sde.tar.TKVRkatastriyksused.valitseja_nimi'] === owner.label) {
                    isFound = true;
                    this.problemForm.current.setModel('objectOwner', owner.value.toString());
                    break;
                }
            }

            if (isFound === false) {
                this.problemForm.current.setModel('objectOwner', '');
            }
        }
        else {
            this.problemForm.current.setModel('objectOwner', '');
        }
    };

    getLayerRenderer = (type) => {
        if (!type) return;

        let typeName = String(type.type).toLowerCase(),
            renderer = null;

        if (type.useServiceIntensityColors) {
            type = prepareServiceIntensityLayers([type])[0];
            setServiceIntensityLayerRenderer(type);
            renderer = type.renderer;
        } else {
            if (typeName === 'point') {
                if (type.icon) {
                    if (type.title === 'Puud') {
                        let symbol = {
                            type: "picture-marker",
                            width: '42pt',
                            height: '42pt',
                        };

                        renderer = {
                            type: "class-breaks", // autocasts as new ClassBreaksRenderer()
                            field: "treeType",
                            classBreakInfos: [],
                        };
                        //Already parsed data
                        for (let i = 0; i < 4; i++) {
                            let treeType = '';
                            if (i === 1) {
                                treeType = 'leaf';
                                symbol.color = type.colorLeaf;
                            } else if (i === 2) {
                                treeType = 'conifer';
                                symbol.color = type.colorConifer;
                            } else if (i === 3) {
                                treeType = 'fruit';
                                symbol.color = type.colorFruit;
                            } else if (i === 0) {
                                treeType = 'undefined';
                                symbol.color = type.colorUndefined;
                            }
                            symbol.url = process.env.REACT_APP_API_V2 + "object_type/" + type.id + "/icon.svg?treeType=" + treeType;

                            renderer.classBreakInfos.push({
                                minValue: i,
                                maxValue: i,
                                symbol: Object.assign({}, symbol),
                            });
                        }
                    } else {
                        renderer = {
                            type: "simple",
                            symbol: {
                                type: "picture-marker",
                                width: '42pt',
                                height: '42pt',
                                url: process.env.REACT_APP_API_V2 + "object_type/" + type.id + "/icon.svg?rand=" + new Date().getTime(),
                            }
                        }
                    }
                } else {
                    renderer = {
                        type: "simple",
                        symbol: {
                            type: "simple-marker",
                            size: '14.1732pt',
                            color: type.color ? convertHex2Array(type.color, 0.7) : [255, 128, 0, 0.7],
                            outline: { color: 'grey', width: 0.5 }
                        }
                    }
                }
            } else if (typeName === 'polygon') {
                renderer = {
                    type: "simple",
                    symbol: {
                        type: "simple-fill",
                        style: "solid",
                        color: type.color ? convertHex2Array(type.color, 0.7) : [255, 128, 0, 0.7],
                        outline: { color: 'white', width: 0.5 },
                    }
                }
            }
        }

        return renderer;
    };

    render() {
        const { t, cityObject } = this.props;
        if (!cityObject.geom) {
            cityObject.geom = {}; //Prevent next multiple map errors
        }

        return (
            <Row>
                <Col sm={12} className={'pt-3 text-right'}>
                    <Button color={'primary'} onClick={this.toggle}>
                        {t('header.registerProblem')}
                    </Button>

                    <Form id={'problemForm'}
                        ref={this.problemForm}
                        schema={problemObjectSchema}
                        onSubmit={this.handleSubmit}>

                        <Modal
                            className="modal-lg modal-dialog-centered"
                            isOpen={this.state.isOpen}
                            toggle={this.toggle}
                        >

                            <ModalHeader toggle={this.toggle}>
                                <strong>{t('modal.header.registerProblem')}</strong>
                            </ModalHeader>

                            <ModalBody>

                                <TextField
                                    type={'hidden'}
                                    name={'cityObjectId'}
                                    value={cityObject.id}
                                />

                                <TextField
                                    name="pointX"
                                    type="hidden"
                                    value={cityObject.geom.point ? cityObject.geom.point.x : 0.00}
                                />

                                <TextField
                                    name="pointY"
                                    type="hidden"
                                    value={cityObject.geom.point ? cityObject.geom.point.y : 0.00}
                                />

                                <Basemap id={'problemMap'}>
                                    <Fullscreen />
                                    <Locate />
                                    <GeoJSONLayer id={'objects'}
                                        index={0}
                                        title={i18n.t('common:sidebar.objects')}
                                        url={process.env.REACT_APP_API_V2 + 'city_objects/object/' + cityObject.id + '.geojson'}
                                        popupEnabled={false}
                                        renderer={this.getLayerRenderer(cityObject.type)}
                                    />
                                    <Polygon
                                        key={cityObject.id}
                                        geometry={cityObject.geom.polygon}
                                        object={cityObject}
                                        wkid={cityObject.geom.srid}
                                        intensityAssignedOnly={true}
                                        outlineColor='white'
                                        outlineWidth={0.5}
                                    />

                                    <GraphicsLayer id={'graph1'}
                                        listMode="hide" />

                                    <PointDraw layerId={'graph1'}
                                        getOwnerOnFirstLoad={cityObject.geom.point}
                                        owner={this.handleSetOwner}
                                        isCityObject={true}
                                        point={{ point: cityObject.geom.point }}
                                        type={cityObject.type}
                                        treeType={cityObject.treeType ? cityObject.treeType.toLowerCase() : false}
                                        update={(value) => this.handleProblemLocationChange(value.coordinates)}
                                        readOnly={cityObject.geom.point}
                                    />

                                </Basemap>

                                <Row className={'mt-4'}>
                                    <Col lg={6}>
                                        <SelectField
                                            required
                                            label={t('fields.problemTypeGroup')}
                                            onChangeValue={this.handleChangeGroup}
                                            name={'typeGroup'}
                                            options={this.state.typeGroupOptions}
                                        />
                                    </Col>
                                    <Col lg={6}>
                                        <SelectField
                                            required
                                            label={t('fields.problemType')}
                                            placeholder={t('fields.problemType')}
                                            name={'type'}
                                            options={this.state.typeOptions}
                                            fieldAttributes={{ disabled: this.state.typeOptions.length < 2 }}
                                        />
                                    </Col>
                                </Row>

                                <TextareaField
                                    name="description"
                                    label={t('fields.description')}
                                />

                                <DropzoneField
                                    id={'problemFiles'}
                                    label={t('sidebar.files')}
                                    defaultMessage={t('fields.dropFilesHere')}
                                    name="files"
                                    mimeTypes={['image/*']}
                                    maxSize={50}
                                    clean={false}
                                    private={true}
                                />

                                <Row className={'mt-4 mb-3'}>
                                    <Col lg={12} className={'text-center'}>
                                        <CheckboxField
                                            onCheck={this.handleNotification}
                                            name="isNotification"
                                            label={t('fields.receiveNotification')}
                                        />
                                    </Col>
                                </Row>

                                {this.state.isNotification &&
                                    <>
                                        <Row>
                                            <Col lg={6}>
                                                <TextField name={'firstName'}
                                                    label={t('fields.firstName')}
                                                    required
                                                />
                                            </Col>
                                            <Col lg={6}>
                                                <TextField name={'lastName'}
                                                    label={t('fields.lastName')}
                                                    required
                                                />
                                            </Col>
                                        </Row>

                                        <Row>
                                            <Col lg={6}>
                                                <TextField name={'email'}
                                                    label={t('fields.email')}
                                                    required />
                                            </Col>
                                            <Col lg={6}>
                                                <TextField name={'phone'} label={t('fields.phone')} />
                                            </Col>
                                        </Row>
                                    </>
                                }

                            </ModalBody>

                            <ModalFooter>
                                <Button color="secondary" onClick={this.toggle}>
                                    {t('form.cancel')}
                                </Button>
                                {' '}
                                <SubmitField className="btn btn-primary"
                                    value={t('form.submit')} />
                            </ModalFooter>
                        </Modal>
                    </Form>
                </Col>
            </Row>
        )
    }
}

const ProblemForm = connect(null, mapDispatchToProps)(ConnectedProblemForm);

export default withNamespaces('common')(ProblemForm);
